<template>
    <div
        v-if="mockData || isImpersonating"
        class="absolute z-50 mt-2 top-(--beyond-safe-area-inset-top) right-2 flex space-x-2 items-center"
    >
        <div
            v-if="mockData"
            class="text-white rounded-full bg-red-500 w-5 h-5 flex items-center opacity-50 justify-center"
        >
            <DIcon
                icon="code-bracket"
                size="w-4 h-4"
            />
        </div>
        <div
            v-if="isImpersonating"
            class="relative w-5 h-5"
        >
            <div class="shape-alert-subtle absolute top-0">
                <DIcon
                    icon="ph:warning-fill"
                    size="w-5 h-5"
                />
            </div>
            <div class="text-(--surface-primary) absolute top-0">
                <DIcon
                    icon="ph:warning"
                    size="w-5 h-5"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { DIcon } from '@digistorm/spark'

    const appStore = useAppStore()
    const { mockData, isImpersonating } = storeToRefs(appStore)
</script>
